import { render } from "./ShowsList.vue?vue&type=template&id=07f3d381&scoped=true"
import script from "./ShowsList.vue?vue&type=script&lang=js"
export * from "./ShowsList.vue?vue&type=script&lang=js"

import "./ShowsList.vue?vue&type=style&index=0&id=07f3d381&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f3d381"]])

export default __exports__